<div class="input-question__container">
  @if (question.minTextLength > 0) {
    <span class="fs__sm caption">{{ 'system.minTextLengthHint' | translate: { min: question.minTextLength } }}</span>
  }

  <mat-form-field appearance="outline" [attr.aria-labelledby]="question.id" [subscriptSizing]="'dynamic'">
    <input
      matInput
      surveyAutoFocus
      autocomplete="off"
      [errorStateMatcher]="immediateErrorMatcher"
      [type]="question.inputType"
      [formControl]="questionCtrl"
      [min]="question.minLength > 0 ? question.minLength : null"
      [max]="question.maxLength > 0 ? question.maxLength : null"
      [minlength]="question.minTextLength > 0 ? question.minTextLength : null"
      [maxlength]="question.maxTextLength > 0 ? question.maxTextLength : null"
      (input)="onInput()"
    />

    @if (loading$()) {
      <div matSuffix class="essay-question__container__suffix">
        <mat-spinner matSuffix diameter="20" color="secondary"></mat-spinner>
      </div>
    }

    @if (question.maxTextLength > 0) {
      <mat-hint class="max-length-hint">{{ questionCtrl.value | charactersLeft: question.maxTextLength }}</mat-hint>
    }

    <mat-error>
      @if (questionCtrl.errors; as error) {
        @if (error.required) {
          <span class="fs__md fw__500 input-question__container__error">{{ 'error.required' | translate }}</span>
        }
        @if (error.message) {
          <span class="fs__md fw__500 input-question__container__error">{{ error.message }}</span>
        }
      }
    </mat-error>
  </mat-form-field>
</div>
